import { IAuditable } from "../auditable";

export class Auditable implements IAuditable {
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;

  constructor(data: IAuditable) {
    this.createdAt = new Date(data.createdAt);
    this.createdBy = data.createdBy;
    this.updatedAt = new Date(data.updatedAt);
    this.updatedBy = data.updatedBy;
  }

  getDaysSinceCreation(): number {
    const diffTime = Math.abs(new Date().getTime() - this.createdAt.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  isModified(): boolean {
    return this.updatedAt.getTime() !== this.createdAt.getTime();
  }
}